// Safety & Emergency hub — official numbers cited from NTB / Department of Tourism
import { EXPLORE_IMAGES } from './exploreImages';
import { OFFICIAL_SOURCES, LAST_VERIFIED } from './officialSources';

export const SAFETY_HUB = {
	title: 'Safety & Emergency in Nepal',
	eyebrow: 'Travel Lifecycle · Emergency',
	hero: EXPLORE_IMAGES.valley,
	lastVerified: LAST_VERIFIED,
	quickFacts: [
		{ value: '1144', label: 'Tourist Police (toll-free)' },
		{ value: '100', label: 'Police' },
		{ value: '102', label: 'Ambulance' },
		{ value: '101', label: 'Fire' },
	],
	lead: 'Nepal is generally safe for tourists. Know these numbers before you need them — Tourist Police (1144) has English-speaking officers and 28 units across the country.',
	sections: [
		{
			id: 'numbers',
			question: 'What are the emergency numbers?',
			source: OFFICIAL_SOURCES.touristPolice,
			answer: 'Tourist Police hotline: 1144 (toll-free, 24/7) — English-speaking officers trained to assist foreigners. General police: 100. Ambulance: 102. Fire: 101. Traffic police: 103. Tourist Police head office: Bhrikutimandap, Kathmandu (inside Nepal Tourism Board premises), +977-1-4247041.',
			tips: ['Save 1144 in your phone before landing.', 'Tourist Police units operate in Kathmandu Valley, Pokhara, Chitwan, and major trekking hubs.'],
		},
		{
			id: 'hospitals',
			question: 'Where do tourists go for medical care?',
			answer: 'CIWEC Clinic Travel Medicine Center (Lazimpat, Kathmandu) — standard for expats and insured tourists; accepts international insurance. Grande International Hospital, Norvic International Hospital, and Patan Hospital are other options in Kathmandu. Bharatpur Hospital serves Chitwan. Pokhara has Western Regional Hospital and few private clinics.',
			tips: ['Travel insurance with evacuation cover is essential for trekking.', 'Pharmacies in Thamel stock altitude medication — consult a doctor before taking Diamox.'],
		},
		{
			id: 'altitude',
			question: 'Altitude sickness — what should I know?',
			answer: 'Acute Mountain Sickness (AMS) can occur above 2,500m. Symptoms: headache, nausea, dizziness, fatigue. Treatment: stop ascending, rest, hydrate, descend if worsening. High Altitude Cerebral Edema (HACE) and Pulmonary Edema (HAPE) are life-threatening — descend immediately and seek evacuation.',
			tips: ['Never fly into Lukla and trek same day — acclimatize.', 'Golden rule: climb high, sleep low.', 'Garlic soup on trails is local remedy — not medical treatment.'],
		},
		{
			id: 'scams',
			question: 'Common safety issues (not dangers)',
			answer: 'Nepal has low violent crime against tourists. Main issues: trekking agency bait-and-switch, gem scams in Thamel, unofficial guides at temples, taxi overcharging, and pickpocketing in crowded markets. Political demonstrations occasionally occur — avoid large crowds.',
			tips: ['Book treks through registered agencies.', 'Use Pathao/inDrive instead of negotiating taxis.', 'See our scams guide for full list.'],
		},
		{
			id: 'water',
			question: 'Is tap water safe?',
			answer: 'No. Drink bottled, boiled, or filtered water only. Avoid ice in cheap restaurants unless you trust the water source. Brush teeth with bottled water in rural areas.',
			tips: ['SteriPEN or water purification tablets useful on treks.', 'Check bottle seals — refilled bottles exist.'],
		},
		{
			id: 'women',
			question: 'Solo female travelers',
			answer: 'Thousands of women trek and travel Nepal solo annually. Standard precautions: dress modestly at temples, avoid walking alone late at night in unfamiliar areas, share trekking plans with someone, and choose registered agencies. Harassment is uncommon but not unheard of — firm refusal usually ends unwanted attention.',
			tips: ['Female trekking guides available through reputable agencies.', 'Tea houses on major routes are accustomed to solo women.'],
		},
		{
			id: 'insurance',
			question: 'Insurance and helicopter rescue',
			answer: 'Helicopter evacuation costs $5,000–$15,000+ without insurance. Ensure your policy covers trekking altitude you will reach (5,500m+ for EBC). Insurance company must authorize rescue — keep emergency number on phone and paper.',
			tips: ['World Nomads and specialist mountaineering insurers commonly used.', 'Confirm evacuation cover explicitly — not all policies include it.'],
		},
	],
	faqs: [
		{ q: 'Is Nepal safe in 2026?', a: 'Yes for tourists on standard itineraries. Check your government travel advisory. Avoid trekking alone in remote areas without experience.' },
		{ q: 'What if I lose my passport?', a: 'Contact your embassy in Kathmandu immediately. Tourist Police (1144) can assist with police report for embassy replacement.' },
		{ q: 'Are earthquakes a risk?', a: 'Nepal is seismically active. Know hotel evacuation routes. After 2015 earthquake, building standards improved in tourist areas.' },
		{ q: 'Can I drink alcohol at altitude?', a: 'Avoid alcohol above 3,000m — worsens dehydration and altitude sickness risk.' },
	],
	officialLinks: [
		{ label: 'Tourist Police (NTB)', url: OFFICIAL_SOURCES.touristPolice.url },
		{ label: 'Department of Tourism — Tourist Police', url: 'https://tourismdepartment.gov.np/pages/tourist-police/' },
		{ label: 'CIWEC Clinic', url: 'https://www.ciwec-clinic.com/' },
	],
	related: [
		{ label: 'Airport arrival', to: '/arrival' },
		{ label: 'Travel insurance', to: '/plan/insurance' },
		{ label: 'Common scams', to: '/guides/common-tourist-scams-how-to-avoid-them' },
		{ label: 'Adventure & trekking', to: '/plan/adventure' },
	],
};
